/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if (sessionStorage.getItem('summaryDisplayed') === 'true') {
    document.querySelector('.dress--cart-dot').removeAttribute('hidden');
} else {
    document.querySelector('.dress--cart-dot').setAttribute('hidden', '');
}

window.addEventListener('DOMContentLoaded', () => {
    const dressSummaryButton = document.querySelector('.dress-summary');

    if (dressSummaryButton) {
        dressSummaryButton.addEventListener('click', function () {
            populateSummaryWithLooks();
            const summaryMenuId = '#main-nav';
            toggleMenuDressSummary(summaryMenuId);
        });
    }

    initMenuHandlersDressSummary();
});

function initMenuHandlersDressSummary() {
    // Handle opening of the menu by js-menu__open class elements
    document.querySelectorAll('.js-menu__open').forEach(menuIcon => {
        menuIcon.addEventListener('click', function () {
            const menuId = menuIcon.getAttribute('data-menu');
            toggleMenuDressSummary(menuId);
        });
    });

    // Handle closing of the menu
    document.querySelectorAll('.js-menu__context, .js-menu__close').forEach(element => {
        element.addEventListener('click', function (event) {
            if (event.target.classList.contains('js-menu__context') || event.target.classList.contains('js-menu__close')) {
                document.querySelectorAll('.js-menu__expanded').forEach(expandedMenu => {
                    expandedMenu.classList.remove('js-menu__expanded');
                });
                document.querySelector('body').style.overflow = "auto";
            }
        });
    });
}

function toggleMenuDressSummary(menuId) {
    const menu = document.querySelector(menuId);
    if (menu) {
        menu.classList.toggle('js-menu__expanded');
        if (menu.parentElement) {
            menu.parentElement.classList.toggle('js-menu__expanded');
        }
        document.querySelector('body').style.overflow = menu.classList.contains('js-menu__expanded') ? "hidden" : "auto";
    }
}

function populateSummaryWithLooks() {
    const menu = document.querySelector('.look-products-content');
    const looks = JSON.parse(sessionStorage.getItem('customerCustomLooks')) || JSON.parse(sessionStorage.getItem('customerLooks'));
    menu.innerHTML = '';
    console.log('looks', looks);
    if (looks && looks.length) {
        document.querySelector('.js-menu .Drawer__Footer').style.display = "block";
        looks.forEach((look, lookIndex) => {
            const lookDiv = document.createElement('div');
            lookDiv.className = 'look';
            lookDiv.innerHTML = `<h2>${lookIndex + 1}.</h2>`;
            look.products.forEach(product => {
                lookDiv.innerHTML += `
                            <div class="menu-product">
                                <div class="look-drawer-content">
                                    <div class="look-drawer-image">
                                        <img src="${product.imageSrc}" alt="${product.title}">
                                    </div>
                                    <div class="look-drawer-info">
                                        <h3>${product.title}</h3>
                                    </div>
                                </div>
                            </div>
            `;
            });
            menu.appendChild(lookDiv);
        });
    } else {
        document.querySelector('.your-looks-container .Drawer__Footer').style.display = "none";
        document.querySelector('.your-looks-container .look-products-content').innerHTML = `
            <p 
                style="display: flex; justify-content: center; padding-top: 2rem;"
            >
                Add items to enquiry form
            </p>
        `;
    }
}

// Find the element with the class 'look-builder-tabs'
const tabsElement = document.querySelector('.look-builder-tabs');

if (tabsElement) {
    // Get the height including padding but not margin
    const tabsHeight = tabsElement.clientHeight; 

    // Set the '--tab-height' CSS variable to the height of 'look-builder-tabs'
    document.documentElement.style.setProperty('--tab-height', `${tabsHeight}px`);

    // Find the element with the class 'look-builder-collection-tabs'
    const collectionTabsElement = document.querySelectorAll('.look-builder-summary');

    if (collectionTabsElement.length) {
        // Use the '--tab-height' CSS variable to set the top position
        collectionTabsElement.forEach(summary => {
            summary.style.top = `var(--tab-height)`;
        })
    } else {
        console.error("Element with class 'look-builder-collection-tabs' was not found.");
    }
} else {
    console.error("Element with class 'look-builder-tabs' was not found.");
}
